import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTag = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.7273 8.93967L8.94732 13.7197C8.82349 13.8436 8.67644 13.942 8.51457 14.0091C8.35271 14.0762 8.17921 14.1107 8.00398 14.1107C7.82876 14.1107 7.65526 14.0762 7.4934 14.0091C7.33153 13.942 7.18448 13.8436 7.06065 13.7197L1.33398 7.99967V1.33301H8.00065L13.7273 7.05967C13.9757 7.30949 14.115 7.64743 14.115 7.99967C14.115 8.35192 13.9757 8.68986 13.7273 8.93967V8.93967Z",
		stroke: "#2171C6",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.66602 4.66699H4.67268",
		stroke: "#2171C6",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgTag;
